import React from "react"
import SurveyCreatorWidget from 'components/FormsAndTemplatesV2/SurveyCreator';
import { useLocation } from 'react-router-dom'
import { useHistory } from "react-router"

/**
 * Renders form template editor parent component. Contains the form editor (survey js component).
 * 
 * @returns 
 */
export function FormEditor() {
  const location = useLocation()
  const { id, json, part, name } = location.state
  const history = useHistory()

  return (
    <div className="add-new-referral-container">
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>
        <div className="add-new-text">{name}</div>
      </div>
      <SurveyCreatorWidget json={json} part={part} id={id} />
    </div>
  );
}
